"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _errorEmitter = require("./errorEmitter");

var _constants = require("../constants");

var _misc = require("./misc");

var logger = {
  log: function log() {
    if ((0, _misc.noWindow)() || !window.silenceLogging) {
      var _console;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // eslint-disable-next-line no-console
      (_console = console).log.apply(_console, [_constants.LOGGING_NAMESPACE].concat(args));
    }
  },
  warn: function warn() {
    if ((0, _misc.noWindow)() || !window.silenceLogging) {
      var _console2;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      // eslint-disable-next-line no-console
      (_console2 = console).warn.apply(_console2, [_constants.LOGGING_NAMESPACE].concat(args));
    }
  },
  error: function error(err) {
    if ((0, _misc.noWindow)() || !window.silenceLogging) {
      err.message = "".concat(_constants.LOGGING_NAMESPACE, ": ").concat(err.message);
      (0, _errorEmitter.errorEmitter)(err);
    }
  }
};
var _default = logger;
exports["default"] = _default;